import { useDispatch, useSelector } from "react-redux";
import {
  setVisible,
  setDescription,
  setTitle,
  spendTrialDesafios,
  spendTrialRoleta,
  spendTrialSolo,
} from "../store/slices/premiumTrial";
import { useTranslation } from "react-i18next";

export default function usePremiumTrial() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { trialDesafios, trialRoleta, trialSolo } = useSelector(
    (state) => state.premiumTrial
  );

  const showModal = (title, description) => {
    dispatch(setVisible(true));
    dispatch(setTitle(title));
    dispatch(setDescription(description));
  };

  const showBlockModal = () => {
    showModal(t("nenhumDesafioRestante"), t("tornePremiumAviso2"));
  };
  const show2CreditsModal = () => {
    showModal(t("desafiosRestantesDois"), t("tornePremiumAviso2"));
  };
  const showPremiumModal = () => {
    showModal(t("conteudoPremium"), t("tornePremiumAviso2"));
  };

  const canPlay = (type) => {
    switch (type) {
      case "desafios":
        return trialDesafios > 0;
      case "roleta":
        return trialRoleta > 0;
      case "solo":
        return trialSolo > 0;
      default:
        return false;
    }
  };

  const spendTrialCredit = (type) => {
    let canPlay = false;
    switch (type) {
      case "desafios":
        if (trialDesafios === 2) {
          show2CreditsModal();
        }
        if (trialDesafios === 0) {
          showBlockModal();
          break;
        }
        canPlay = true;
        dispatch(spendTrialDesafios());
        break;
      case "roleta":
        if (trialRoleta === 2) {
          show2CreditsModal();
        }
        if (trialRoleta === 0) {
          showBlockModal();
          break;
        }
        canPlay = true;
        dispatch(spendTrialRoleta());
        break;
      case "solo":
        if (trialSolo === 2) {
          show2CreditsModal();
        }
        if (trialSolo === 0) {
          showBlockModal();
          break;
        }
        canPlay = true;
        dispatch(spendTrialSolo());
        break;
      default:
        break;
    }

    return canPlay;
  };

  return { spendTrialCredit, canPlay, showPremiumModal, showBlockModal };
}
